import script from "./MagneticButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MagneticButton.vue?vue&type=script&setup=true&lang=js"

import "./MagneticButton.vue?vue&type=style&index=0&id=28ae271b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ae271b"]])

export default __exports__